import React, {useState} from 'react';
import styles from './rating-stars.module.scss';
import cl from 'classnames';
import { RatingStarsProps } from './rating-stars.types';
import { IconStarHalf, IconStar } from '../../../assets/icons/index';

const RatingStarsComponent = (props: RatingStarsProps) => {
  const {
    rating,
    reviewsCount: count,
    className,
    style,
    selfRating,
    isAdmin,
    rate,
    disabled
  } = props;

  const [localRating, setLocalRating] = useState(rating);
  const [hoverIndex, setHoverIndex] = useState(0);

  const ratingText = rating === null ? '' : rating;
  const countText = count === undefined ? '' : `(${count})`;
  const isSelf = selfRating === true;

  const onRate = (index: number) => {
    if (isSelf && !isAdmin && (rate !== null) && !disabled) {
      rate(index + 1);
      setLocalRating(index + 1 );
    }
  };

  const onHover = (index: number) => {
    if (isSelf && !isAdmin && !disabled) {
      setHoverIndex(index + 1);
    }
  };

  return (
    <div className={cl(styles.ratingStars, className)} style={style} onMouseLeave={ () => onHover( - 1) }>

      {Array(5).fill('').map((_, index) => {
        const starNumber = index + 1;
        let dynRate = hoverIndex > 0 ? hoverIndex : localRating;
        if (dynRate == null) {
          dynRate = 0;
        }
        switch (true) {
          case dynRate < starNumber && dynRate > starNumber - 1:
            return <IconStarHalf key={index} fill={styles.primary} />;
          case dynRate >= starNumber:
            return <IconStar key={index} fill={styles.primary}
                             onClick={ () => onRate(index) }
                             onMouseEnter={ () => onHover(index) } />;
          case dynRate < starNumber:
            return <IconStar key={index}
                             onClick={ () => onRate(index) }
                             onMouseEnter={ () => onHover(index) } />;
          default: return null;
        }
      })}
      {!isSelf && <span>{ratingText} {countText}</span>}
    </div>
  );
};

const RatingStars = RatingStarsComponent;
export { RatingStars };
